import { render, staticRenderFns } from "./ConceptContents.vue?vue&type=template&id=205aae30&"
import script from "./ConceptContents.vue?vue&type=script&lang=ts&"
export * from "./ConceptContents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports